const mapAssetsToGallery = (assets) => assets.map((x) => ({
  id: x.sys.id,
  title: x.fields.title,
  file: x.fields.file,
}))

export default mapAssetsToGallery
